import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../carrying-out-works.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { CarryingOutWorksStatementForm } from './forms/carrying-out-works-statement.form';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';

@Component({
  selector: 'app-carrying-out-works-statement-section',
  standalone: true,
  imports: [
    StagesComponent,
    ReactiveFormsModule,
    CommonModule,
    SpinnerComponent,
    AlertComponent
  ],
  providers: [CarryingOutWorksStatementForm],
  templateUrl: './carrying-out-works-statement-section.component.html'
})
export class CarryingOutWorksStatementSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public stages: string[] = stages;

  public form: CarryingOutWorksStatementForm = inject(CarryingOutWorksStatementForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../oplaty'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
